import { rem } from "@mantine/core";
import IconProps from "./types";


const MarkerPinIcon = ({ size = 24, style, ...others }: IconProps) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...others}
            style={{ width: rem(size), height: rem(size), ...style }}
        >
            <path d="M12 13.228C13.6569 13.228 15 11.8849 15 10.228C15 8.57117 13.6569 7.22803 12 7.22803C10.3431 7.22803 9 8.57117 9 10.228C9 11.8849 10.3431 13.228 12 13.228Z" stroke={others.color ?? "white"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 22.228C16 18.228 20 14.6463 20 10.228C20 5.80975 16.4183 2.22803 12 2.22803C7.58172 2.22803 4 5.80975 4 10.228C4 14.6463 8 18.228 12 22.228Z" stroke={others.color ?? "white"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default MarkerPinIcon